<template>
  <div id="evaluate-category">
    <mainHeader class="mainHeader"></mainHeader>
    <div class="wrapper">
      <div class="section section1">
        <div class="title">风险评测</div>
      </div>
      <div class="section section2">
        <div class="image"></div>
      </div>
      <div class="section section3" v-show="parentId===0||parentId===-1">
        <div class="top" v-show="parentId===0">请选择企业经营场所 <span>(多选)</span></div>
        <div class="top" v-show="parentId===-1">请选择企业场地 <span>(多选)</span></div>
        <div class="content" v-for="(item,index) in 1" :key="index">
          <div class="cat-value" v-for="(value,index) in categoryData" :key="index"
            :class="{'defaultItem': !value.isSel,'isItemSel': value.isSel}" @click="itemClick(value)">{{value.name}}
          </div>
        </div>
      </div>
      <div class="section section3" v-show="parentId > 0">
        <div class="top">请选择企业经营场所 <span>(多选)</span></div>
        <div class="content" v-for="(item,index) in categoryData" :key="index">
          <div class="cat-title">{{item.name}} :</div>
          <div class="cat-value" v-for="(value,ind) in item.list" :key="ind"
            :class="{'defaultItem': !value.isSel,'isItemSel': value.isSel}" @click="itemClick2(value,index,ind)">
            {{value.name}}</div>
        </div>
      </div>
    </div>
    <bottomButton title="下一步" :state="bottomState" @click="bottomClick"></bottomButton>
  </div>
</template>

<script>
import mainHeader from '../view/header'
import bottomButton from '../components/bottom-button'
export default {
  data () {
    return {
      parentId: 0,
      bottomState: 0,
      selectNumber: 0, // 选中个数
      categoryData: [],
      progress: 0
    }
  },
  methods: {
    bottomClick: function (type) {
      console.log('================下一步')

      // 提交选择 分类
      var _this = this
      var categoryIds = ''
      if (this.parentId === 0) { // 一级分类 点击下一步 到 二级分类
        console.log('一级分类========================')
        var data = []
        for (var i = 0; i < this.categoryData.length; i++) {
          let item = this.categoryData[i]
          if (item.isSel === 1) {
            data.push(item)
          }
        }
        this.categoryData = data
        console.log(this.categoryData)
        this.bottomState = 0
        this.selectNumber = 0

        for (var i2 = 0; i2 < this.categoryData.length; i2++) {
          let item = this.categoryData[i2]
          this.loadData(item.id, i2 + 1)
        }
      } else if (this.parentId === -1) { // 三级分类
        console.log('三级分类答题========================')
        for (let i = 0; i < this.categoryData.length; i++) {
          let item = this.categoryData[i]
          if (item.isSel === 1) {
            categoryIds += (item.id + ',')
          }
        }
        if (categoryIds.indexOf(',') >= 0) {
          categoryIds = categoryIds.slice(0, categoryIds.length - 1)
        }
        console.log(categoryIds)
        let param = {
          'siteCategoryIds': categoryIds
        }
        let userinfo = JSON.parse(localStorage.getItem('userinfo'))
        this.utils.POSTHeader(this.accountUrl + '/riskeval/commitSiteCategory', { 'phone': userinfo.tails.userinfo[0].phone }, param, function (response) {
          _this.$router.push({ path: 'evaluate-question', query: { categoryIds: categoryIds } })
        })
      } else { // 二级分类 点击下一步
        console.log('二级分类========================')
        for (var i3 = 0; i3 < this.categoryData.length; i3++) {
          for (var j = 0; j < this.categoryData[i3].list.length; j++) {
            let item = this.categoryData[i3].list[j]
            if (item.isSel === 1) {
              categoryIds += (item.id + ',')
            }
          }
        }
        if (categoryIds.indexOf(',') >= 0) {
          categoryIds = categoryIds.slice(0, categoryIds.length - 1)
        }
        console.log(categoryIds)
        let param = {
          'siteCategoryIds': categoryIds
        }
        // 提交选择 分类
        let userinfo = JSON.parse(localStorage.getItem('userinfo'))
        this.utils.POSTHeader(this.accountUrl + '/riskeval/commitSiteCategory', { 'phone': userinfo.tails.userinfo[0].phone }, param, function (response) {
          _this.$router.push({ path: 'evaluate-question', query: { categoryIds: categoryIds } })
        })
      }
    },
    itemClick: function (value) { // 一级分类 点击
      if (value.isSel === 1) {
        value.isSel = 0
        this.selectNumber -= 1
      } else {
        value.isSel = 1
        this.selectNumber += 1
      }
      // 底部按钮 状态
      if (this.selectNumber > 0) {
        this.bottomState = 1
      } else {
        this.bottomState = 0
      }
    },
    itemClick2: function (value, index, ind) { // 二级分类  选择
      if (value.isSel === 1) {
        value.isSel = 0
        this.selectNumber -= 1
      } else {
        value.isSel = 1
        this.selectNumber += 1
      }

      if (this.selectNumber > 0) {
        this.bottomState = 1
      } else {
        this.bottomState = 0
      }
      // 同步 数据更新 视图不更新
      this.$set(this.categoryData[index], ind, value)
    },
    loadData: function (parentId, index) {
      this.progress = this.$route.query.progress
      // 查询 场所
      var _this = this
      this.utils.GET(this.accountUrl + '/riskeval/getSiteByParentId?parentId=' + parentId, function (response) {
        var result = response.data
        for (let i = 0; i < result.length; i++) {
          var item = result[i]
          item.isSel = 0
        }
        if (parseInt(parentId) === 0) {
          console.log('一级分类===================')
          _this.categoryData = result
        } else {
          if (parseInt(_this.progress) === 1) {
            console.log('三级分类===================')
            _this.categoryData = _this.categoryData.concat(result)
            _this.parentId = -1
          } else {
            console.log('二级分类===================')
            if (result.length > 0) {
              for (var i = 0; i < _this.categoryData.length; i++) {
                let item = _this.categoryData[i]
                if (item.id === parseInt(result[0].parent_id)) {
                  _this.categoryData[i].list = result
                  break
                }
              }
            }
            if (index === _this.categoryData.length) {
              setTimeout(function () {
                _this.parentId = 1
              }, 1000)
            }
          }
        }
        console.log(_this.categoryData)
      })
    }
  },
  watch: {
    $router () {
    }
  },
  computed: {

  },
  components: {
    mainHeader,
    bottomButton
  },
  mounted () {
    // 0 一级分类
    let categoryIds = this.$route.query.categoryIds
    if (categoryIds.indexOf(',') >= 0) {
      let categoryIdArray = categoryIds.split(',')
      for (let i = 0; i < categoryIdArray.length; i++) {
        this.loadData(categoryIdArray[i], i + 1)
      }
    } else if (parseInt(categoryIds) > 0) {
      this.loadData(categoryIds, 0)
    } else {
      this.loadData(categoryIds, 0)
    }
  }
}
</script>

<style scoped>
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.wrapper {
  background-color: #f4f4f4;
  /*height: 100%;*/
  margin-top: 55px;
  padding-bottom: 65px;
}
.section {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  background-color: #ffffff;
}
.section .title {
  height: 50px;
  line-height: 50px;
  color: #000;
  font-size: 16px;
  font-weight: bold;
  margin-left: 15px;
}
.section1 {
  height: 50px;
}
.section2 {
  height: 180px;
}
.section2 .image {
  width: 100%;
  height: 180px;
  background-image: url("../assets/icon_evaluate.jpg");
  background-size: cover;
  background-position: center center;
}
.section3 {
  min-height: 100px;
}
.section3 .top {
  height: 70px;
  line-height: 70px;
  color: #000;
  font-size: 16px;
  text-align: center;
}
.section3 .top span {
  color: #808080;
  font-size: 11px;
}
.section3 .content {
  /*width: 100%;*/
  margin: 0 15px;
  /*height: auto;*/
}
.section3 .content .cat-title {
  height: 40px;
  line-height: 40px;
  color: #000;
  font-size: 14px;
}
.section3 .content .cat-value {
  position: relative;
  display: inline-block;
  min-width: 80px;
  margin: 0px 15px 20px 0;
  padding: 0 15px;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  text-align: center;
  border-radius: 3px;
}
.defaultItem {
  color: #000;
  border: solid #eeeeee 1px;
  box-sizing: border-box;
}
.isItemSel {
  border: solid #c41335 1px;
  box-sizing: border-box;
  color: #c41335;
}
</style>



// WEBPACK FOOTER //
// src/view/evaluate-category.vue